// 지문 워크시트 템플릿 로더

export const generatePassageWorksheetHTML = async (passageData, vocabularyData, analysisData) => {
  try {
    // 템플릿 파일 로드
    const templateResponse = await fetch('/templates/passageWorksheet.html');
    if (!templateResponse.ok) {
      throw new Error('템플릿 파일을 불러올 수 없습니다.');
    }
    
    let template = await templateResponse.text();
    
    // 현재 날짜 생성
    const creationDate = new Date().toLocaleDateString('ko-KR');
    
    // 템플릿 변수 치환
    template = template.replace(/{{TOPIC}}/g, passageData.topic || '영어 학습');
    template = template.replace(/{{GRADE_LEVEL}}/g, passageData.gradeLevel || '');
    template = template.replace(/{{CREATION_DATE}}/g, creationDate);
    template = template.replace(/{{PASSAGE_TEXT}}/g, passageData.passage || '');
    
    // 지문 분석 데이터
    template = template.replace(/{{WORD_COUNT}}/g, analysisData.wordCount || 0);
    template = template.replace(/{{VOCABULARY_USAGE}}/g, analysisData.vocabularyUsageRate || '0');
    template = template.replace(/{{USED_VOCAB_COUNT}}/g, analysisData.usedVocabularyCount || 0);
    template = template.replace(/{{SENTENCE_COUNT}}/g, analysisData.sentenceCount || 0);
    
    // 핵심 어휘 HTML 생성
    const vocabularyItemsHTML = generateVocabularyItemsHTML(analysisData.keyVocabulary || []);
    template = template.replace(/{{VOCABULARY_ITEMS}}/g, vocabularyItemsHTML);
    
    // 핵심 문법 HTML 생성
    const grammarItemsHTML = generateGrammarItemsHTML(analysisData.grammarPoints || []);
    template = template.replace(/{{GRAMMAR_ITEMS}}/g, grammarItemsHTML);
    
    // 해설 텍스트
    template = template.replace(/{{EXPLANATION_TEXT}}/g, analysisData.explanation || '지문에 대한 상세 해설이 제공됩니다.');
    
    return template;
  } catch (error) {
    console.error('지문 워크시트 HTML 생성 오류:', error);
    throw error;
  }
};

// 핵심 어휘 HTML 생성
const generateVocabularyItemsHTML = (vocabulary) => {
  if (!vocabulary || vocabulary.length === 0) {
    return '<div class="vocab-item"><div class="vocab-english">No vocabulary data</div><div class="vocab-korean">어휘 데이터가 없습니다</div></div>';
  }
  
  return vocabulary.map(item => `
    <div class="vocab-item">
      <div class="vocab-english">${item.english || item.word || ''}</div>
      <div class="vocab-korean">${item.korean || item.meaning || ''}</div>
    </div>
  `).join('');
};

// 핵심 문법 HTML 생성
const generateGrammarItemsHTML = (grammarPoints) => {
  if (!grammarPoints || grammarPoints.length === 0) {
    return `
      <li class="grammar-item">
        <div class="grammar-title">문법 분석 중...</div>
        <div class="grammar-example">지문의 핵심 문법 포인트가 분석되어 제공됩니다.</div>
      </li>
    `;
  }
  
  return grammarPoints.map(point => `
    <li class="grammar-item">
      <div class="grammar-title">${point.title || point.grammar || ''}</div>
      <div class="grammar-example">${point.example || point.explanation || ''}</div>
    </li>
  `).join('');
};

export default {
  generatePassageWorksheetHTML
};